@if (visible()) {
	<div class="flex flex-col gap-3" [class]="styleClass()" data-cy="subscription-notifies">
		@if (expiredVehicles().length) {
			<subscription-notify
				[isInternalUser]="isInternalUser()"
				[type]="SubscriptionNotifyType.EXPIRED"
				[userEmail]="userEmail()"
				[userName]="userName()"
				[vehicles]="expiredVehicles()"
			></subscription-notify>
		}
		@if (expireSoonVehicles().length) {
			<subscription-notify
				class="print:hidden"
				[isInternalUser]="isInternalUser()"
				[type]="SubscriptionNotifyType.EXPIRE_SOON"
				[userEmail]="userEmail()"
				[userName]="userName()"
				[vehicles]="expireSoonVehicles()"
			></subscription-notify>
		}
	</div>
}
